module.exports = __webpack_public_path__ + "static/img/ia_100000006.b3f84321.png";